import React from 'react';
import { Link } from 'react-router-dom';
import { trackPixel } from '../../utils/pixel';
type Variant = 'primary' | 'outline' | 'ghost' | 'whatsapp';
type Size = 'sm' | 'md' | 'lg' | 'xl';
const base = 'inline-flex items-center justify-center gap-2 rounded-xl font-semibold whitespace-nowrap transition-[transform,background-color,border-color,color,box-shadow] duration-150 ease-smooth active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-neon text-white shadow-[0_10px_30px_-14px_rgba(31,123,255,0.9)] hover:bg-neon-soft hover:shadow-[0_0_28px_-6px_rgba(31,123,255,0.85)]',
  outline: 'border border-neon/40 bg-surface2/60 text-white hover:border-neon hover:bg-surface2 hover:shadow-[0_0_26px_-10px_rgba(31,123,255,0.9)]',
  ghost: 'text-mist hover:text-white',
  whatsapp: 'bg-[#1fae5a] text-white hover:bg-[#25c264] hover:shadow-[0_0_26px_-8px_rgba(37,194,100,0.8)]'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-3.5 text-[13px]',
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-[15px]',
  xl: 'h-14 px-7 text-[16px] font-bold md:h-16 md:px-9 md:text-[17px]'
};
interface CommonProps {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
}
function cls(p: CommonProps) {
  return `${base} ${variants[p.variant ?? 'primary']} ${sizes[p.size ?? 'md']} ${p.className ?? ''}`;
}
export function Button({
  variant,
  size,
  className,
  children,
  ...rest
}: CommonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button className={cls({
    variant,
    size,
    className,
    children
  })} {...rest} data-id="element-404" data-mp="xmo06bmjfvtx">
      {children}
    </button>;
}
export function ButtonLink({
  to,
  variant,
  size,
  className,
  children
}: CommonProps & {
  to: string;
}) {
  return <Link to={to} className={cls({
    variant,
    size,
    className,
    children
  })} data-id="element-405" data-mp="1lf4lqw5hi5xz">
      {children}
    </Link>;
}
export function ButtonAnchor({
  href,
  variant,
  size,
  className,
  children,
  ariaLabel
}: CommonProps & {
  href: string;
  ariaLabel?: string;
}) {
  const isWhatsapp = href.includes('wa.me');
  return <a href={href} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel} onClick={isWhatsapp ? () => trackPixel('Contact') : undefined} className={cls({
    variant,
    size,
    className,
    children
  })} data-id="element-406" data-mp="1tfka31i2twg9">
      {children}
    </a>;
}